export enum TipoLog {
  TRANSFERENCIA = 'TRANSFERENCIA',
  CRIACAO = 'CRIACAO',
  EDICAO = 'EDICAO',
  EXCLUIR = 'EXCLUIR',
  FECHAMENTO = 'FECHAMENTO',
  INATIVACAO = 'INATIVACAO',
  REVOGAR = 'REVOGAR',
  ASSOCIACAO = 'ASSOCIACAO',
  DESASSOCIAR = 'DESASSOCIAR',
  PERMICAO = 'PERMICAO',
  MUDANCA_CANAL = 'MUDANCA_CANAL',
  MUDANCA_ETAPA = 'MUDANCA_ETAPA',
  MUDANCA_FLUXO = 'MUDANCA_FLUXO',
  REINICIO_SESSAO = 'REINICIO_SESSAO',
  ENCERRAMENTO_ATENDIMENTO = 'ENCERRAMENTO_ATENDIMENTO',
  SESSAO_DERRUBADA = 'SESSAO_DERRUBADA'
}
